// edit.component.ts - VERSIÓN OPTIMIZADA

import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';
import { AdminService } from '../../services/admin/admin.service';
import { HttpClient, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {
  @Output() lista = new EventEmitter<boolean>();
  @Input() id_banner: number;

  modalRef: BsModalRef;
  config = {
    class: 'modal-dialog-centered modal-app modal-app-lg',
    backdrop: true,
    ignoreBackdropClick: true
  };

  bannerForm: FormGroup;
  submitted: boolean = false;
  preloader: boolean = false;
  div_error: number = 0;
  div_text_error: string = '';

  // Archivos seleccionados (NUEVOS)
  selectedWebFile: File | null = null;
  selectedMobileFile: File | null = null;
  webFileName: string = '';
  mobileFileName: string = '';

  // Datos del banner actual
  currentBanner: any = {};
  currentImageWeb: string = '';
  currentImageMobile: string = '';

  // Preview de imágenes seleccionadas
  webImagePreview: string = '';
  mobileImagePreview: string = '';

  // Banderas para saber si hay imágenes existentes
  hasExistingWebImage: boolean = false;
  hasExistingMobileImage: boolean = false;

  // Bandera para saber si el modal está listo
  modalReady: boolean = false;

  // NUEVO: Banderas para detectar cambios en imágenes
  webImageChanged: boolean = false;
  mobileImageChanged: boolean = false;

  constructor(
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    public helper: HelpersService,
    public admin: AdminService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.bannerForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      title: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(200)]],
      description: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]],
      imageWeb: [null],
      imageMobile: [null],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      order: [1, [Validators.required, Validators.min(1)]],
      active: [true],
      bannerType: ['promotional', [Validators.required]],
      linkUrl: [''],
      linkText: [''],
      displayDuration: [5000, [Validators.min(1000)]]
    });
  }

  get f() {
    return this.bannerForm.controls;
  }

  openModal(template: TemplateRef<any>) {
    this.loadBannerData(template);
  }

  loadBannerData(template: TemplateRef<any>) {
    this.preloader = true;
    this.modalReady = false;

    this.admin.getBanner(this.id_banner).subscribe({
      next: (data: any) => {
        console.log('Banner data loaded:', data);

        this.currentBanner = data;

        // Asignar imágenes con fallback
        this.currentImageWeb = data.image_web || 'assets/img/no-image-web.png';
        this.currentImageMobile = data.image_mobile || 'assets/img/no-image-mobile.png';

        // Inicializar previews con imágenes actuales
        this.webImagePreview = this.currentImageWeb;
        this.mobileImagePreview = this.currentImageMobile;

        // Verificar si hay imágenes existentes
        this.hasExistingWebImage = !!(data.image_web && data.image_web.trim());
        this.hasExistingMobileImage = !!(data.image_mobile && data.image_mobile.trim());

        // Establecer nombres de archivos actuales
        if (this.hasExistingWebImage) {
          this.webFileName = this.extractFileNameFromUrl(data.image_web);
        }
        if (this.hasExistingMobileImage) {
          this.mobileFileName = this.extractFileNameFromUrl(data.image_mobile);
        }

        console.log('Images loaded:', {
          web: this.currentImageWeb,
          mobile: this.currentImageMobile,
          hasWeb: this.hasExistingWebImage,
          hasMobile: this.hasExistingMobileImage,
          webFileName: this.webFileName,
          mobileFileName: this.mobileFileName
        });

        // Convertir fechas al formato datetime-local
        const startDate = data.start_date ? new Date(data.start_date).toISOString().slice(0, 16) : '';
        const endDate = data.end_date ? new Date(data.end_date).toISOString().slice(0, 16) : '';

        this.bannerForm.patchValue({
          name: data.name || '',
          title: data.title || '',
          description: data.description || '',
          startDate: startDate,
          endDate: endDate,
          order: data.order || 1,
          active: data.active || false,
          bannerType: data.banner_type || 'promotional',
          linkUrl: data.link_url || '',
          linkText: data.link_text || '',
          displayDuration: data.display_duration || 5000
        });

        this.resetModalState();
        this.modalReady = true;
        this.preloader = false;

        // Abrir modal después de cargar datos
        this.modalRef = this.modalService.show(template, this.config);
      },
      error: (error) => {
        this.preloader = false;
        this.helper.modalError('Error al cargar los datos del banner');
        console.error('Error al cargar banner:', error);
      }
    });
  }

  closeModal() {
    this.modalRef.hide();
    this.resetModalState();
  }

  resetModalState() {
    this.submitted = false;
    this.preloader = false;
    this.div_error = 0;
    this.div_text_error = '';
    this.selectedWebFile = null;
    this.selectedMobileFile = null;
    this.modalReady = false;

    // NUEVO: Resetear banderas de cambio
    this.webImageChanged = false;
    this.mobileImageChanged = false;

    // Limpiar previews
    this.webImagePreview = '';
    this.mobileImagePreview = '';
  }

  private extractFileNameFromUrl(url: string): string {
    if (!url) return '';

    const urlParts = url.split('/');
    const fileName = urlParts[urlParts.length - 1];

    if (fileName.includes('.')) {
      return fileName;
    }

    return fileName + '.jpg';
  }

  onWebFileSelected(event: any) {
    const file = event.target.files[0];
    if (file && this.isValidImageFile(file)) {
      this.selectedWebFile = file;
      this.webFileName = file.name;
      this.webImageChanged = true; // NUEVO: Marcar que cambió
      this.bannerForm.patchValue({ imageWeb: file });

      // Crear preview de la imagen seleccionada
      this.createImagePreview(file, 'web');
    } else {
      this.selectedWebFile = null;
      this.webFileName = '';
      this.webImageChanged = false; // NUEVO: No cambió
      this.bannerForm.patchValue({ imageWeb: null });

      // Restaurar imagen original
      this.webImagePreview = this.currentImageWeb;

      if (file) {
        this.helper.modalError('Solo se permiten archivos JPG, PNG y JPEG');
      }
    }
  }

  onMobileFileSelected(event: any) {
    const file = event.target.files[0];
    if (file && this.isValidImageFile(file)) {
      this.selectedMobileFile = file;
      this.mobileFileName = file.name;
      this.mobileImageChanged = true; // NUEVO: Marcar que cambió
      this.bannerForm.patchValue({ imageMobile: file });

      // Crear preview de la imagen seleccionada
      this.createImagePreview(file, 'mobile');
    } else {
      this.selectedMobileFile = null;
      this.mobileFileName = '';
      this.mobileImageChanged = false; // NUEVO: No cambió
      this.bannerForm.patchValue({ imageMobile: null });

      // Restaurar imagen original
      this.mobileImagePreview = this.currentImageMobile;

      if (file) {
        this.helper.modalError('Solo se permiten archivos JPG, PNG y JPEG');
      }
    }
  }

  private createImagePreview(file: File, type: 'web' | 'mobile') {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      if (type === 'web') {
        this.webImagePreview = e.target.result;
      } else {
        this.mobileImagePreview = e.target.result;
      }
    };
    reader.readAsDataURL(file);
  }

  clearWebFile() {
    this.selectedWebFile = null;
    this.webImagePreview = this.currentImageWeb;
    this.webImageChanged = false; // NUEVO: Resetear bandera
    this.bannerForm.patchValue({ imageWeb: null });

    // Restaurar nombre del archivo original si existe
    if (this.hasExistingWebImage) {
      this.webFileName = this.extractFileNameFromUrl(this.currentImageWeb);
    } else {
      this.webFileName = '';
    }

    // Limpiar input file
    const fileInput = document.getElementById('webFile') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  clearMobileFile() {
    this.selectedMobileFile = null;
    this.mobileImagePreview = this.currentImageMobile;
    this.mobileImageChanged = false; // NUEVO: Resetear bandera
    this.bannerForm.patchValue({ imageMobile: null });

    // Restaurar nombre del archivo original si existe
    if (this.hasExistingMobileImage) {
      this.mobileFileName = this.extractFileNameFromUrl(this.currentImageMobile);
    } else {
      this.mobileFileName = '';
    }

    // Limpiar input file
    const fileInput = document.getElementById('mobileFile') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  private isValidImageFile(file: File): boolean {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    return validTypes.includes(file.type.toLowerCase());
  }

  onSubmit() {
    this.preloader = true;
    this.div_error = 0;

    // Preparar datos para actualización
    const formData = this.bannerForm.value;
    const updateData: any = {
      name: formData.name,
      title: formData.title,
      description: formData.description,
      start_date: formData.startDate,
      end_date: formData.endDate,
      order: formData.order,
      active: formData.active,
      banner_type: formData.bannerType,
      link_url: formData.linkUrl,
      link_text: formData.linkText,
      display_duration: formData.displayDuration
    };

    this.updateBanner(updateData);
  }

  private getFormValidationErrors() {
    const result = [];
    Object.keys(this.bannerForm.controls).forEach(key => {
      const controlErrors = this.bannerForm.get(key).errors;
      if (controlErrors) {
        result.push({
          control: key,
          errors: controlErrors
        });
      }
    });
    return result;
  }

  private showValidationErrors() {
    const errors = this.getFormValidationErrors();
    if (errors.length > 0) {
      let errorMessage = 'Por favor, corrija los siguientes errores:<br>';
      errors.forEach(error => {
        const fieldName = this.getFieldDisplayName(error.control);
        errorMessage += `• ${fieldName}: ${this.getErrorMessage(error.errors)}<br>`;
      });
      this.div_error = 1;
      this.div_text_error = errorMessage;
    }
  }

  private getFieldDisplayName(fieldName: string): string {
    const fieldNames: { [key: string]: string } = {
      'name': 'Nombre',
      'title': 'Título',
      'description': 'Descripción',
      'startDate': 'Fecha de inicio',
      'endDate': 'Fecha de fin',
      'order': 'Orden',
      'bannerType': 'Tipo de banner',
      'displayDuration': 'Duración'
    };
    return fieldNames[fieldName] || fieldName;
  }

  private getErrorMessage(errors: any): string {
    if (errors.required) return 'Es requerido';
    if (errors.minlength) return `Mínimo ${errors.minlength.requiredLength} caracteres`;
    if (errors.maxlength) return `Máximo ${errors.maxlength.requiredLength} caracteres`;
    if (errors.min) return `Debe ser mayor a ${errors.min.min}`;
    return 'Valor inválido';
  }

  private updateBanner(updateData: any) {
    // NUEVO: Optimización - Solo enviar imágenes si cambiaron
    if (this.webImageChanged || this.mobileImageChanged) {
      console.log('Actualizando con imágenes cambiadas...');
      this.updateWithFiles(updateData);
    } else {
      console.log('Actualizando sin cambios en imágenes...');
      this.updateWithoutFiles(updateData);
    }
  }

  private updateWithFiles(updateData: any) {
    // NUEVO: Crear objeto con la estructura esperada, incluyendo solo imágenes que cambiaron
    const bannerData: any = {
      name: updateData.name,
      title: updateData.title,
      description: updateData.description,
      startDate: updateData.start_date,
      endDate: updateData.end_date,
      order: updateData.order,
      active: updateData.active,
      bannerType: updateData.banner_type,
      linkUrl: updateData.link_url,
      linkText: updateData.link_text,
      displayDuration: updateData.display_duration
    };

    // NUEVO: Solo agregar imágenes si cambiaron
    if (this.webImageChanged && this.selectedWebFile) {
      console.log('Agregando imagen web al objeto');
      bannerData.imageWeb = this.selectedWebFile;
    }

    if (this.mobileImageChanged && this.selectedMobileFile) {
      console.log('Agregando imagen mobile al objeto');
      bannerData.imageMobile = this.selectedMobileFile;
    }

    console.log('Objeto preparado con imágenes:', {
      webChanged: this.webImageChanged,
      mobileChanged: this.mobileImageChanged,
      webFile: !!this.selectedWebFile,
      mobileFile: !!this.selectedMobileFile,
      hasImageWeb: !!bannerData.imageWeb,
      hasImageMobile: !!bannerData.imageMobile
    });

    this.admin.updateBannerFormData(this.id_banner, bannerData).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          const progress = Math.round(100 * event.loaded / event.total);
          console.log(`Upload progress: ${progress}%`);
        } else if (event.type === HttpEventType.Response) {
          console.log('Update successful:', event.body);
          this.preloader = false;
          this.helper.modalSuccess('¡Banner actualizado exitosamente!');
          this.lista.emit(true);
          this.closeModal();
        }
      },
      error: (error) => {
        console.error('Error updating with files:', error);
        this.preloader = false;
        this.div_error = 1;
        this.div_text_error = 'Error al actualizar el banner. Por favor, intente nuevamente.';
        this.helper.error('Error al actualizar banner', error);
      }
    });
  }

  private updateWithoutFiles(updateData: any) {
    console.log('Enviando datos sin imágenes:', updateData);

    this.admin.updateBanner(this.id_banner, updateData).subscribe({
      next: (response) => {
        console.log('Update successful:', response);
        this.preloader = false;
        this.helper.modalSuccess('¡Banner actualizado exitosamente!');
        this.lista.emit(true);
        this.closeModal();
      },
      error: (error) => {
        console.error('Error updating without files:', error);
        this.preloader = false;
        this.div_error = 1;
        this.div_text_error = 'Error al actualizar el banner. Por favor, intente nuevamente.';
        this.helper.error('Error al actualizar banner', error);
      }
    });
  }

  // Métodos legacy para mantener compatibilidad
  banner_id(template: TemplateRef<any>) {
    this.openModal(template);
  }

  update_image() {
    this.onSubmit();
  }
}
